import React, { useState } from "react";
import { useNavigate, Link } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import { formatApiErrorDetail } from "@/lib/api";
import { Crest } from "@/components/Crest";
import { Input } from "@/components/ui/input";

export default function Register() {
  const { register } = useAuth();
  const nav = useNavigate();
  const [form, setForm] = useState({ name: "", email: "", password: "", role: "applicant" });
  const [error, setError] = useState("");
  const submit = async (e) => {
    e.preventDefault();
    setError("");
    try { await register(form); nav("/apply"); }
    catch (err) { setError(formatApiErrorDetail(err.response?.data?.detail) || err.message); }
  };
  return (
    <div className="min-h-screen flex items-center justify-center bg-paper p-8">
      <form onSubmit={submit} className="w-full max-w-sm">
        <Link to="/" className="flex items-center gap-3 mb-8"><Crest className="h-10 w-10" /><span className="font-serif text-2xl text-ink">Simo University</span></Link>
        <h1 className="font-serif text-4xl text-ink">Create your account</h1>
        {error && <div data-testid="register-error" className="mt-4 text-sm text-destructive">{error}</div>}
        <div className="mt-6 space-y-3">
          <Input data-testid="register-name" required placeholder="Full name" value={form.name} onChange={(e) => setForm({ ...form, name: e.target.value })} className="rounded-sm" />
          <Input data-testid="register-email" type="email" required placeholder="Email" value={form.email} onChange={(e) => setForm({ ...form, email: e.target.value })} className="rounded-sm" />
          <Input data-testid="register-password" type="password" required minLength={6} placeholder="Password (min 6 characters)" value={form.password} onChange={(e) => setForm({ ...form, password: e.target.value })} className="rounded-sm" />
          <div className="flex gap-2">
            {[["applicant", "I am the applicant"], ["parent", "I am a parent/guardian"]].map(([v, l]) => (
              <button type="button" key={v} onClick={() => setForm({ ...form, role: v })} className={`flex-1 text-sm py-2 rounded-sm border transition-colors ${form.role === v ? "bg-ink text-paper border-ink" : "border-border text-ink/70"}`}>{l}</button>
            ))}
          </div>
        </div>
        <button data-testid="register-submit" className="mt-6 w-full bg-heraldic text-white py-3 rounded-sm hover:bg-heraldic-700 transition-colors">Create account</button>
        <p className="mt-4 text-sm text-ink/55">Already have an account? <Link to="/login" className="text-heraldic">Log in</Link></p>
      </form>
    </div>
  );
}
